export default __webpack_public_path__ + "static/media/DJI_0988.MP4.00_00_29_23.Still001.9716a826.jpg";